import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const bidsListSlice = createSlice({
  name: "bidsListSlice",
  initialState,
  //REDUCER
  reducers: {
    setBidsList(state, action) {
      return {
        ...state,
        rows: action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    addBid(state, action) {
      return {
        ...state,
        rows: [...state.rows, action.payload],
      };
    },
    editBid(state, action) {
      return {
        ...state,
        rows: state.rows.map((row) =>
          row.id === action.payload.id ? action.payload : row
        ),
      };
    },
    deleteBid(state, action) {
      return {
        ...state,
        rows: state.rows.filter((row) => row.id !== action.payload),
      };
    },
  },
});

//ACTIONS
export const {
    setBidsList,
    showLoading,
    hideLoading,
    addBid,
    editBid,
    deleteBid,
} = bidsListSlice.actions;

export default bidsListSlice.reducer;
